import { render, staticRenderFns } from "./ChainForm.vue?vue&type=template&id=1cfc3585"
import script from "./ChainForm.vue?vue&type=script&lang=ts"
export * from "./ChainForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports